import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Get, Postdata, Post } from "../../utils/api.services";
import { toast } from "react-toastify";
import HttpService from "../../utils/https.services";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { SuccessModal } from "../../utils/common";
import { useNavigate } from "react-router-dom";

const STRIPE_PUBLISHABLE_KEY =
  "pk_live_51PSei4A5ZMXlc3ZwRowDJfgjS5T6TlRpRwMl0OswgLkTiPdYkvaoWgr65sAyN1rH0GbH2cO2QS0jM6V8HXmy9yY600awXjdofO";
// "pk_test_51PSei4A5ZMXlc3ZwBFSSWoR0oSojJ7AsgYjqrxO0XFNfWtWDyxkNrOobymW7fzNXjNuBWQSMlFAXFgi6PtrBa9cB00KdgkDk9b"
// const STRIPE_SECRET =
//   "sk_test_51PSei4A5ZMXlc3ZwKwQZLcaTqtmFtR2uvFyrNp9JdDZFZSgMVmavH4LCMmlbbxJBnJQKgQpCkxpLRKBYrPtAgMYE00KOJKui7T";

let stripePromise;

const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY).catch((error) => {
      console.error("Failed to load Stripe.js", error);
      toast.error(
        "Unable to load payment form. Check your connection and try again."
      );
      return null;
    });
  }
  return stripePromise;
};

const StripeComponent = ({ data, onClose }) => {
  //   const StripeENV = process.env.STRIPE_SECRET_KEY_LIVE;// STRIPE_SECRET_KEY_LIVE

  // console.log(StripeENV, "Stripe env");

  const navigate = useNavigate();
  const options = {
    allow_promotion_codes: true,
    // passing the client secret obtained from the server
    // clientSecret : "pi_3PxiuVA5ZMXlc3Zw1AMITubj_secret_WV6qReECy9Sqj59FiUs7vGAO1"
    clientSecret: window.sessionStorage.getItem("client_secret"), // "pi_3Pe9LTA5ZMXlc3Zw0nebO2N4_secret_D94kx1j6lNALrQ0QuxjGbBgMd",
  };
  const [isModalActive, setModalActive] = useState(false);

  useEffect(() => {}, [data]);

  const handleSuccess = () => {
    if (data.type === "course") {
      Get(
        `${HttpService()?.registerUser}?courseId=${
          data.lmsdetails._id
        }&transactionId=${data.transactionId}`
      )
        .then((result) => {
          // navigate("/lms/common", {
          //   state: { id: id, lmsdetails: data?.lmsdetails },
          // });
          setModalActive(true);
          if (result?.status) {
          } else {
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (data.type === "subscription") {
      navigate("/home/profile/plus");
    } else if (data.type === "coin_purchase") {
      Postdata(HttpService()?.achiveRewards, {
        type: "in_app_purchase",
        amount: data.coins,
      })
        .then((result) => {
          if (result?.status) {
            onClose();
            navigate("/home/profile/earn/rewards");
            onClose();
            toast.success(result?.message);
          } else {
            toast.error(result?.message);
          }
        })
        .catch((e) => {
          toast.error(e?.response?.data?.message);
        });
    } else if (data.type === "virtual_balance") {
      onClose();
      toast.success("Virtual Currency purchased successfully");
    } else if (data.type === "toro_purchase") {
      onClose();
      toast.success("Toro Portfolios purchased successfully");
    }
  };

  const closeModal = () => {
    setModalActive(false);
    // navigate(`/lms/course/${data?.id}`);
    navigate("/lms/common", {
      state: { id: data?.id, lmsdetails: data?.lmsdetails },
    });
  };

  useEffect(() => {}, [data]);

  return (
    <div>
      {data && (
        <Elements stripe={getStripe()} options={options}>
          <CheckoutForm handleSuccess={handleSuccess} data={data} />
        </Elements>
      )}
      <SuccessModal
        isActive={isModalActive}
        onClose={closeModal}
        title="You have purchased course successfully"
        onClick={closeModal}
      />
    </div>
  );
};

const CheckoutForm = ({ handleSuccess, data }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: "https://web-dev.rallybulls.com/home/profile/plus",
      },
      redirect: "if_required",
    });
    if (result.error) {
      toast.error(result.error.message);
    } else {
      var payload = {
        type: "subscription_cancel",
        record_id: data.current_plan_id,
      };
      Post(`${HttpService()?.payment}`, payload)
        .then((result) => {
          if (result?.message) {
          }
        })
        .catch((error) => {
          console.error("Error during payment:", error);
        })
        .finally(() => {
          toast.success("Payment successful! Thank you for your purchase.");

          handleSuccess();
        });
    }
  };

  return (
    <form>
      <PaymentElement />
      <div
        className="page-cta my-2"
        style={{ position: "static", display: "block" }}
      >
        <button
          className="cta-btn cta-fill cta-lg"
          style={{ fontSize: "16px" }}
          onClick={handleSubmit}
        >
          Purchase ${data?.paymentData?.total || data?.paymentData?.amount}
        </button>
      </div>
    </form>
  );
};

export default StripeComponent;
